export interface SubCategoryLine {
  /** local row id for React keying */
  localId: string
  /** backend id (0 for new rows) */
  id: number
  nameEn: string
  nameAr: string
  isActive: boolean
  isDeleted: boolean
}

export function newSubCategoryLine(partial?: Partial<SubCategoryLine>): SubCategoryLine {
  return {
    localId: partial?.localId ?? `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    id: partial?.id ?? 0,
    nameEn: partial?.nameEn ?? '',
    nameAr: partial?.nameAr ?? '',
    isActive: partial?.isActive ?? true,
    isDeleted: partial?.isDeleted ?? false,
  }
}
